/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Page_LoadingInputs */

const en_edit_page_loading = /** @type {(inputs: Edit_Page_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading edit page`)
};

const pt_br2_edit_page_loading = /** @type {(inputs: Edit_Page_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando página de edição`)
};

/**
* | output |
* | --- |
* | "Loading edit page" |
*
* @param {Edit_Page_LoadingInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const edit_page_loading = /** @type {((inputs?: Edit_Page_LoadingInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Page_LoadingInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_edit_page_loading(inputs)
	return pt_br2_edit_page_loading(inputs)
});